/**
 * Dropdown state for the create-user role field.
 * A single returned role is preselected and locked. A non-collaborator
 * stays locked even when the list has not arrived yet.
 */

/**
 * @param {Array<{ value: string, label: string }>|null|undefined} roles
 * @param {boolean} esColaborador
 * @returns {{ roles: Array<{ value: string, label: string }>, tipoDeUsuario: string|null, locked: boolean }}
 */
export const creatableRoleState = (roles, esColaborador) => {
  const list = Array.isArray(roles) ? roles : [];
  if (list.length === 1) {
    return {
      roles: list,
      tipoDeUsuario: String(list[0].value),
      locked: true,
    };
  }
  if (!esColaborador) {
    return { roles: list, tipoDeUsuario: "3", locked: true };
  }
  return { roles: list, tipoDeUsuario: null, locked: false };
};

/**
 * @param {Array<{ value: string, label: string }>} roles
 * @param {string|null|undefined} tipoDeUsuario
 * @returns {{ value: string, label: string }|null}
 */
export const selectedCreatableRole = (roles, tipoDeUsuario) => {
  if (!Array.isArray(roles) || roles.length === 0) {
    return null;
  }
  if (roles.length === 1) {
    return roles[0];
  }
  if (tipoDeUsuario == null || tipoDeUsuario === "") {
    return null;
  }
  return (
    roles.find((role) => String(role.value) === String(tipoDeUsuario)) ?? null
  );
};
